import { IFormRender, Row } from '@busybusy/webapp-react-ui';
import { DeleteIcon } from 'assets/icons';
import { EquipmentPickerFormField, IconButton } from 'components';
import Typography from 'components/foundation/text/Typography/Typography';
import { useOrganization } from 'hooks';
import * as React from 'react';
import { t } from 'utils/localize';
import { MULTIPLE } from '../BulkEditEntryForm/BulkEditEntryForm';
import { BulkEditActions, BulkEditActionType, IUndoableClearableFieldState } from '../reducers/reducers';

export interface IEquipmentTrashRowProps<T> {
  form: IFormRender<T>;
  bulkState: IUndoableClearableFieldState;
  dispatch: React.Dispatch<BulkEditActions>;
  className?: string | object;
}

function EquipmentTrashRow<T>({ form, bulkState, dispatch, className }: IEquipmentTrashRowProps<T>) {
  const { trackEquipment } = useOrganization();
  if (!trackEquipment) {
    return null;
  }

  function clearField() {
    dispatch({ type: BulkEditActionType.CLEAR_CURRENT });
  }

  function onChange(id: string | null) {
    dispatch({ type: BulkEditActionType.SET_CURRENT, payload: { value: id } });
  }

  function onUndo(event: React.MouseEvent) {
    event.stopPropagation();
    dispatch({ type: BulkEditActionType.UNDO_CURRENT });
  }

  function renderUndo() {
    return (
      <Typography className={'mx-2'} onClick={onUndo} color={'primary'} tag={'span'}>
        {t('Undo')}
      </Typography>
    );
  }

  return (
    <Row className="trash-row">
      <EquipmentPickerFormField
        name="equipment"
        placeholder={
          bulkState.original === MULTIPLE && bulkState.current === null
            ? t('Equipment will be set to "No Equipment".')
            : t('Equipment')
        }
        onSelect={onChange}
        form={form}
        closeButtonRender={bulkState.undoable ? renderUndo : undefined}
        dropDownButtonRender={bulkState.undoable ? renderUndo() : undefined}
      />
      {bulkState.clearable && <IconButton className="trash-icon" onClick={clearField} svg={DeleteIcon} />}
    </Row>
  );
}

export default EquipmentTrashRow;
